var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _circle, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationCargoNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5V9.61328C8 7.40414 9.79086 5.61328 12 5.61328H31.3865C33.5956 5.61328 35.3865 7.40414 35.3865 9.61328V28.9998C35.3865 31.2089 33.5956 32.9998 31.3865 32.9998H17",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7461 3.14258L14.7461 5.27264",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3506 3.14258L29.3506 5.27264",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1152 19.1025H15.1009",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 19.1025H21.1859",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 24.1748H21.1859",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2861 19.1025H27.2718",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2861 24.1748H27.2718",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.91406,
    y1: 12.5791,
    x2: 34.4748,
    y2: 12.5791,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 26.7143,
    r: 7.71429,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85093 21.2861C8.50496 21.2861 9.03516 21.8163 9.03516 22.4704V27.3019C9.03516 27.9559 8.50496 28.4861 7.85093 28.4861C7.19689 28.4861 6.6667 27.9559 6.6667 27.3019V22.4704C6.6667 21.8163 7.19689 21.2861 7.85093 21.2861ZM7.85093 29.8861C8.50496 29.8861 9.03516 30.4163 9.03516 31.0704V31.1019C9.03516 31.7559 8.50496 32.2861 7.85093 32.2861C7.19689 32.2861 6.6667 31.7559 6.6667 31.1019V31.0704C6.6667 30.4163 7.19689 29.8861 7.85093 29.8861Z",
    fill: "#F47A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCargoNegative);
export default __webpack_public_path__ + "static/media/notification-cargo-negative.992b60fa6f13fa48a87b4e7253862d18.svg";
export { ForwardRef as ReactComponent };